export default __webpack_public_path__ + "static/media/logo.d1628e88.svg";